module.exports = "#statements-head{\r\n    display:inline-block;\r\n    width: 35%;\r\n    border-bottom: 1.5px solid #13507e;\r\n}"